import { toast } from "sonner"

const getErrorMessage = (err: any, fallback: string): string => {
  return err?.response?.data?.error || fallback
}

const openV2ErrorToast = (err: any, fallback: string) => {
  const message = getErrorMessage(err, fallback)
  toast.error(message)
}

export { getErrorMessage, openV2ErrorToast }
